import { render, staticRenderFns } from "./PagePayment.vue?vue&type=template&id=1e289b7c&scoped=true&lang=pug&"
import script from "./PagePayment.vue?vue&type=script&lang=js&"
export * from "./PagePayment.vue?vue&type=script&lang=js&"
import style0 from "./PagePayment.vue?vue&type=style&index=0&id=1e289b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e289b7c",
  null
  
)

export default component.exports